(window as any).AudioContext =
  (window as any).AudioContext || (window as any).webkitAudioContext;

let context: AudioContext | null;

export const getAudioContext = (): AudioContext => {
  if (!context) {
    context = new AudioContext();
    if (context && (window as any).unmute) {
      (window as any).unmute(context);
    }
  }
  return context;
};



// WEBPACK FOOTER //
// ./src/audio/Context.ts